import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { collection, query, onSnapshot } from 'firebase/firestore';
import { db } from '../firebaseConfig';

const GuestList = () => {
  const [guests, setGuests] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const guestsCollection = collection(db, 'guest');

    const guestsQuery = query(guestsCollection);

    // Subscribe to the guests collection for live updates
    const unsubscribe = onSnapshot(guestsQuery, (snapshot) => {
      const updatedGuests = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));

      setGuests(updatedGuests.sort((a, b) => {
        const nameA = a.name.toUpperCase(); // ignore upper and lowercase
        const nameB = b.name.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      }));
    });

    return () => unsubscribe();
  }, []);

  return (
    <div>
      <h1>Guest List</h1>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Phone Number</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {guests.map((guest) => (
            <tr key={guest.id}>
              <td>{guest.name}</td>
              <td>{guest.email}</td>
              <td>{guest.phoneNumber}</td>
              <td>
                <Link to={`/admin-guest-edit/${guest.id}`}>Edit</Link>
              </td>
             
              <td>
                <Link to={`/guest-access/${guest.id}`}>Questions</Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button onClick={() => { navigate("/admin-add-guest") }}>Add Guest</button>
      <br></br>
    </div>
  );
};

export default GuestList;
